<h2 mat-dialog-title>Add Category</h2>
<mat-dialog-content>
  <!-- <mat-form-field> -->
    <mat-label>Category Name</mat-label>
    <input name="category" [(ngModel)]="categoryName">
  <!-- </mat-form-field> -->
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button (click)="onSave()">Save</button>
</mat-dialog-actions>
